import { includes } from 'lodash';

import type {
  PositionHandler,
  XValueParams,
} from 'hb-builder/components/BuilderComponents/single/PageImage/types';
import { HORIZONTAL_ALIGNMENT } from 'hb-builder/constants/alignment';

export const isHorizontalHandler = (position: PositionHandler) =>
  includes(['left', 'right'], position);

export const isVerticalHandler = (position: PositionHandler) =>
  includes(['top', 'bottom'], position);

export const getXValue = ({
  horizontalAlign,
  defaultValue,
  imageWidth,
  wrapperWidth,
}: XValueParams) => {
  if (horizontalAlign === HORIZONTAL_ALIGNMENT.left) {
    return 0;
  }
  if (horizontalAlign === HORIZONTAL_ALIGNMENT.center) {
    return (wrapperWidth - imageWidth) / 2;
  }
  if (horizontalAlign === HORIZONTAL_ALIGNMENT.right) {
    return wrapperWidth - imageWidth;
  }

  return defaultValue;
};
